import axios from 'axios';

const state = {
    subscriptions: [],
    loading: false,
    error: null
};

const getters = {
    subscriptions: s => s.subscriptions,
    activeSubscription: s => s.subscriptions.find(sub => sub.status === 'active' || sub.status === 'trialing'),
    subscriptionStatus: (s, g) => g.activeSubscription?.status,
};

const actions = {
    async fetchUserSubscriptions({ commit, rootState }) {
        const email = rootState.users?.user?.email;
        if (!email) return;
        try {
            commit('setLoading', true);
            // Canonical path chosen: /user/subscriptions (update here if backend standard changes)
            const { data } = await axios.get('/stripe/user/subscriptions', { params: { user_email: email } });
            commit('setSubscriptions', data);
        } catch (e) {
            commit('setError', e);
        } finally {
            commit('setLoading', false);
        }
    }
};

const mutations = {
    setSubscriptions(state, subs) { state.subscriptions = subs || []; },
    setLoading(state, v) { state.loading = v; },
    setError(state, e) { state.error = e; }
};

export default { state, getters, actions, mutations };
